import { useEffect, useRef } from "react";

/** Vidéo muette en boucle qui ne se télécharge et ne démarre qu'une fois visible à l'écran (page plus légère sur mobile). */
export function LazyAutoplayVideo(props) {
  const ref = useRef(null);
  useEffect(() => {
    const v = ref.current;
    if (!v || typeof IntersectionObserver === "undefined") return undefined;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) v.play().catch(() => {});
      else v.pause();
    }, { threshold: 0.25 });
    io.observe(v);
    return () => io.disconnect();
  }, []);
  return <video ref={ref} muted loop playsInline controls preload="none" {...props} />;
}
